import { useTranslation } from 'react-i18next';

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="px-4 md:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left image */}
          <div className="lg:w-2/5 w-full">
            <div className="rounded-[32px] overflow-hidden aspect-[4/5] bg-accent-100">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20lifestyle%20portrait%20of%20person%20in%20cozy%20minimalist%20interior%2C%20soft%20natural%20light%20through%20window%20creating%20gentle%20atmosphere%2C%20neutral%20cream%20and%20sand%20toned%20space%20with%20organic%20textures%2C%20editorial%20authentic%20lifestyle%20photography%2C%20calm%20relaxed%20mood%2C%20warm%20refined%20scandinavian%20aesthetic%20with%20potted%20greenery&width=800&height=1000&seq=testimonial-v2-img-e1&orientation=portrait"
                alt="Nutzer Erfahrung"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          {/* Right content */}
          <div className="lg:w-3/5 flex flex-col gap-6">
            <span className="text-xs font-medium text-foreground-400 tracking-wider">
              ({t('testimonial.label')})
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              {t('testimonial.title_line1')}<br />
              <span className="text-foreground-400">{t('testimonial.title_line2')}</span>
            </h2>
            <blockquote className="text-base md:text-lg text-foreground-600 leading-relaxed italic mt-4 border-l-2 border-accent-300 pl-5">
              &ldquo;{t('testimonial.quote')}&rdquo;
            </blockquote>
            <div className="flex items-center gap-3 mt-2">
              <span className="w-8 h-[1px] bg-foreground-400"></span>
              <span className="text-sm font-semibold text-foreground-800">{t('testimonial.author')}</span>
              <span className="text-sm text-foreground-500">— {t('testimonial.role')}</span>
            </div>

            {/* Nav arrows */}
            <div className="flex items-center gap-3 mt-4">
              <button className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-400 hover:text-foreground-700 hover:border-foreground-400 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-left-line"></i>
              </button>
              <button className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}